<template>
  <v-dialog v-model="dialog" width="600">
    <gg-card>
      <gg-toolbar @close="close">
        Delete Installation
      </gg-toolbar>
      <gg-card-text>
        <v-row>
          <v-col cols="12" class="px-2">
            <p class="mb-0" v-if="installation">
              This will delete your {{ appName }} installation for {{ installation.softdomain }}.
            </p>
          </v-col>
        </v-row>
      </gg-card-text>
      <v-card-actions class="px-5 pt-0 pb-3 justify-content-end">
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn :loading="loading" @click="deleteInstallation">Delete</gg-btn>
      </v-card-actions>
    </gg-card>
  </v-dialog>
</template>

<script>
// todo: this modal is also used in Apps Installer -> InstallationsList.vue, consider moving to another folder
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'
import amapi from '@/api/amapi'

export default {
  name: 'DeleteModal',
  mixins: [modalMixin],
  props: {
    installation: {
      type: Object,
      validate (val) {
        return val === null || val.hasOwnProperty('insid')
      }
    },
    appName: {
      type: String,
      default: 'WordPress'
    },
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async deleteInstallation () {
      this.loading = true
      const params = {
        method: `remove&insid=${this.installation.insid}`,
        _username: this.$route.query.user,
        payload: {
          removeins: 1,
          remove_dir: 1,
          remove_datadir: 1,
          remove_db: 1,
          remove_dbuser: 1,
          noemail: 1,
        }
      }
      try {
        const response = await amapi.softaculous_api(params)
        if (!response.done) {
          throw new Error(response.error[0] ?? 'Deletion error.')
        }
        this.reportSuccess('Installation deleted.')
        this.$emit('deleted')
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
